import {atomWithReset} from 'jotai/utils';

import {LoggedInUserInformation} from '_/utilities';

export const userState = atomWithReset<LoggedInUserInformation>(
  // user is marked as not undefined because the main part of the application only gets loaded
  // when the user is fetched and set in this state, this is simply to avoid having to write ! everytime the user
  // is used
  undefined!
);
